import {Component, effect} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {Router, RouterModule} from '@angular/router';
import {UserService} from '@services/user/user.service';

@Component({
  selector: 'app-pde-guest',
  imports: [MatButtonModule, RouterModule],
  template: `<div class="content-pane">
    <h2>Access Denied</h2>
    <p>Please log in to access the Private Data Enclave.</p>
    <p>
      Note that if you are logged in and seeing this message, the organization you are logged into doesn't have access
      to the Private Data Enclave.
    </p>
    <a [routerLink]="['/login']" matButton="filled">Log In</a>
  </div>`,
})
export class PDEGuestComponent {
  constructor(
    private readonly userService: UserService,
    private readonly router: Router,
  ) {
    effect(() => {
      if (this.userService.userSignal()) {
        this.router.navigate(['/private-data-enclave'], {replaceUrl: true});
      }
    });
  }
}
